import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import VouchersApi from '../../api/vouchersApi';
import { actions as notificationActions } from '../../actions/notificationActions';

const voucherCodeModes = {
  shared: 'Jeden kod',
  unique: 'Kody jednorazowe',
};

const formatDateTime = value => value ? new Date(value).toLocaleString('pl-PL') : '';
const isSuccessfulResponse = response => response.ok && (!response.data || response.data.success !== false);

class VoucherPromotionDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promotion: null,
      loading: false,
    };

    this.loadPromotion = this.loadPromotion.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
  }

  componentDidMount() {
    this.loadPromotion();
  }

  loadPromotion() {
    this.setState({ loading: true });
    return VouchersApi.getPromotion(this.props.match.params.id)
      .then(response => {
        if (response.ok) {
          this.setState({ promotion: response.data });
          return;
        }

        this.props.notificationActions.showError('Nie udało się pobrać promocji voucherowej');
      })
      .finally(() => this.setState({ loading: false }));
  }

  handleDisable() {
    const { promotion } = this.state;
    return VouchersApi.disablePromotion(promotion.id).then(response => {
      if (isSuccessfulResponse(response)) {
        this.props.notificationActions.showSuccess('Promocja została wyłączona');
        return this.loadPromotion();
      }

      this.props.notificationActions.showError('Nie udało się wyłączyć promocji');
      return null;
    });
  }

  renderCodes() {
    const { promotion } = this.state;
    if (!promotion.codes || !promotion.codes.length) return null;

    return (
      <Paper style={{ padding: 16, marginTop: 24 }}>
        <Typography variant="subtitle1" gutterBottom>Kody</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Końcówka kodu</TableCell>
              <TableCell>Użycia</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {promotion.codes.map((code, index) => (
              <TableRow key={`${code.codeSuffix}-${index}`}>
                <TableCell>{code.codeSuffix}</TableCell>
                <TableCell>{code.redemptionsCount} / {code.maxRedemptions}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }

  renderRedemptions() {
    const { promotion } = this.state;
    if (!promotion.redemptions || !promotion.redemptions.length) return null;

    return (
      <Paper style={{ padding: 16, marginTop: 24 }}>
        <Typography variant="subtitle1" gutterBottom>Realizacje</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Końcówka kodu</TableCell>
              <TableCell>Użytkownik</TableCell>
              <TableCell>Klient</TableCell>
              <TableCell>Plan kupiony</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {promotion.redemptions.map(redemption => (
              <TableRow key={redemption.id}>
                <TableCell>{formatDateTime(redemption.redeemedAt)}</TableCell>
                <TableCell>{redemption.codeSuffix}</TableCell>
                <TableCell>{redemption.userName || redemption.userId}</TableCell>
                <TableCell>{redemption.clientName || redemption.clientId}</TableCell>
                <TableCell>{redemption.planBoughtName || redemption.planBoughtId}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }

  render() {
    const { promotion, loading } = this.state;
    if (loading && !promotion) {
      return <div className="page"><div style={{ margin: 40 }}>Ładowanie...</div></div>;
    }
    if (!promotion) return null;

    return (
      <div className="page">
        <div style={{ margin: 40 }}>
          <Paper style={{ padding: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <Typography variant="h5" gutterBottom>{promotion.name}</Typography>
                <Typography>Plan: {promotion.planName}</Typography>
                <Typography>Tryb: {voucherCodeModes[promotion.codeMode] || promotion.codeMode}</Typography>
                <Typography>Ważna od: {formatDateTime(promotion.validFrom)}</Typography>
                <Typography>Ważna do: {formatDateTime(promotion.validTo)}</Typography>
                <Typography>Użycia: {promotion.redemptionsCount} / {promotion.maxRedemptions}</Typography>
                <Typography>Status: {promotion.disabled ? 'Wyłączona' : 'Włączona'}</Typography>
              </div>
              {!promotion.disabled && (
                <Button variant="outlined" color="secondary" onClick={this.handleDisable}>
                  Wyłącz promocję
                </Button>
              )}
            </div>
          </Paper>
          {this.renderCodes()}
          {this.renderRedemptions()}
        </div>
      </div>
    );
  }
}

VoucherPromotionDetailsPage.propTypes = {
  match: PropTypes.object.isRequired,
  notificationActions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    notificationActions: bindActionCreators(notificationActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(VoucherPromotionDetailsPage);
